import { PREMIUM_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';
import type { RouterDataContext, ResourceStoreContext } from '@atlassian/react-resource-router';
import { getAnnouncementDismissState } from '../get-announcement-dismiss-state';
import type { JsmRepackagingAnnouncement } from './types';

export default async function getData(
	_: RouterDataContext,
	{ tenantContext }: ResourceStoreContext,
): Promise<JsmRepackagingAnnouncement> {
	if (
		tenantContext.appEditions.serviceDesk === PREMIUM_EDITION ||
		!tenantContext.atlassianAccountId
	) {
		return {
			announcementDismissState: {
				shouldShow: false,
			},
		};
	}

	const announcementDismissState = await getAnnouncementDismissState({
		accountId: tenantContext.atlassianAccountId,
	});

	return {
		announcementDismissState,
	};
}
